export interface ICopyUsableValues {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
}

export const copyUsableValues = (source: ICopyUsableValues, target: ICopyUsableValues) => {
    Object.keys(source).forEach((key) => {
        if (source[key] !== null && source[key] !== undefined) {
            target[key] = source[key];
        }
    });
};
